<!-- src/routes/(app)/(authentication)/(signup)/+layout.svelte -->
<script lang="ts">
	import { ArrowLeftOutline } from 'flowbite-svelte-icons';
	import { loginLeftBlockState } from '$lib/stores/loginLeftBlockStore';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { get } from 'svelte/store';
	import Button from '$lib/components/ui/Button.svelte';
	import Logo from '$lib/icons/Logo.svelte';
	import neverStopLearningIcon from '$lib/assets/navigation/Never-stop-Learning.svg';

	const states = ['free', 'existing', 'expired'];

	onMount(() => {
		const urlState = get(page).url.searchParams.get('state');
		if (urlState && states.includes(urlState)) {
			loginLeftBlockState.set(urlState);
		}
	});

	const changeState = (state: string) => {
		loginLeftBlockState.set(state);
		const url = new URL(window.location.href);
		url.searchParams.set('state', state);
		history.pushState({}, '', url);
	};
</script>

<div class="flex min-h-screen w-full flex-col items-stretch bg-secondary-950 md:flex-row">
	<div
		class="relative order-2 flex min-h-[700px] w-full flex-col justify-between bg-secondary-950 p-2 md:order-1 md:w-[100%] md:p-12"
	>
		<div class="hidden w-full md:block">
			<a href="/" class="flex h-8">
				<Logo class="h-full text-white" />
			</a>
		</div>
		<img
			src={neverStopLearningIcon}
			alt="new website"
			class="absolute right-2 top-8 h-32 object-cover object-center md:right-0 md:top-4 md:block md:h-48 lg:right-16"
		/>

		<div
			class="m-auto flex w-auto max-w-[460px] flex-col items-start justify-center gap-6 pt-16 text-white md:gap-12 lg:w-2/3"
		>
			{#if $loginLeftBlockState === 'buttons'}
				<h2 class="text-3xl">Welcome to the new Wrap Institute website</h2>
				<p>The 2 ways to wrapping wisdom:</p>
				<a href="/register">
					<Button
						class="w-60 md:w-72"
						color="primary"
						size="lg"
						on:click={() => changeState('free')}>Start for free</Button
					>
				</a>
				<a href="/pricing">
					<Button class="w-60 md:w-72" color="primary" size="lg">Buy Membership</Button>
				</a>
			{:else if $loginLeftBlockState === 'free'}
				<div>
					<h2 class="text-3xl">Start discovering<br /> The Wrap Institute for free</h2>
					<ul class="my-8 mb-6 space-y-4 text-lg">
						<li class="items-top flex">
							<span class="mr-2 text-green-500">✔</span>
							A selection of free videos covering various wrapping topics
						</li>
						<li class="items-top flex">
							<span class="mr-2 text-green-500">✔</span>
							Free video reviews on tools and wrapping products
						</li>
						<li class="items-top flex">
							<span class="mr-2 text-green-500">✔</span>
							Access to directory
						</li>
						<li class="items-top flex">
							<span class="mr-2 text-green-500">✔</span>
							Newsletter
						</li>
						<li class="items-top flex">
							<span class="mr-2 text-green-500">✔</span>
							Your personal profile page
						</li>
					</ul>
					<p class="text-ml text-gray-400">
						If you are interested in unlocking the full content like tons of video content, townhall
						talks or discount codes to lots of products, just choose one of the available
						subscription models after registration.
					</p>
					<p class="mt-6 flex items-center justify-end uppercase">
						<a
							class="flex items-center gap-2 text-sm text-white hover:text-primary-400"
							href="/login"
							on:click={() => changeState('buttons')}><ArrowLeftOutline class="w-4" /> Back</a
						>
					</p>
				</div>
			{/if}
		</div>

		<div></div>
	</div>

	<div
		class="order-1 flex min-h-[700px] w-full flex-col justify-between bg-black p-2 pt-8 text-white md:order-2 md:w-[100%] md:p-12"
	>
		<div class="mb-16 w-full md:hidden">
			<a href="/" class="flex h-8">
				<Logo class="h-full text-white" />
			</a>
		</div>

		<div class="flex items-center justify-end gap-2 px-6 text-sm uppercase"></div>

		<div>
			<slot />
		</div>

		<div></div>
	</div>
</div>
